import { listen, qs, remove, toggle } from "@fluorescent/dom";
import PredictiveSearch from "@/lib/predictive-search";

const defaultOptions = {
  el: {
    clear: "[data-search-clear]",
    input: "[data-input]",
    results: "[data-search-results]",
    search: "[data-search-submit]",
  },
  strings: {
    articles: "Articles",
    pages: "Pages",
    products: "Products",
    view_all: "View all",
  },
  show_articles: true,
  show_pages: true,
  show_products: true,
  show_vendor: false,
  show_price: true,
  limit: 4,
};

export default function Search(container, options = {}) {
  const opts = Object.assign(defaultOptions, options);

  // Elements
  const input = qs(opts.el.input, container);
  const resultsContainer = qs(opts.el.results, container);
  const clearButton = qs(opts.el.clear, container);
  const searchButton = qs(opts.el.search, container);

  // Events
  const inputChange = listen(input, "input", handleInputChange);
  const clearClick = listen(clearButton, "click", reset);

  // This gets replaced with a focus trapping util on `open` however
  // this should prevent any errors if the quick search is destroyed
  // when it wasn't open
  let lockbox = () => {};

  const predictiveSearch = new PredictiveSearch(resultsContainer);

  function handleInputChange({ target: { value } }) {
    toggle(
      [resultsContainer, clearButton, searchButton],
      "visible",
      value !== ""
    );

    predictiveSearch.getSearchResults(value);
  }

  function reset(e) {
    e.preventDefault();
    input.value = "";
    remove([resultsContainer, clearButton, searchButton], "visible");
    resultsContainer.innerHTML = "";
    input.focus();
    lockbox();
  }

  function destroy() {
    inputChange();
    clearClick();
  }

  return { destroy };
}
